import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { getTotem, setAuthToken, setCidade } from '../../api/apiFactory';
import {
  fetchLimparCookie, fetchNomeCidade, fetchServico, fetchVerificarStatusCidade,
} from '../../api/endpoints';
import {
  definirCidade, desfazerCidade, fetchConfiguracoesCidade, selectCidade,
} from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import { resetarModais, selectModal } from '../../app/slices/modalSlice';
import { desfazerSecretaria } from '../../app/slices/secretariasSlice';
import AppHeader from '../../components/AppHeader/AppHeader';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalLogin from '../../components/ModalLogin/ModalLogin';
import {
  AppBody, AppFragment, Container, Interno, Titulo,
} from '../../styles/base';
import Botao from '../../components/Botao/Botao';
import Carregar from '../../components/Carregar/Carregar';
import CardCartaServicos from '../../components/CardCartaServicos/CardCartaServicos';

const IniciarCartaServicos = () => {
  const dadosModal = useSelector(selectModal);
  const dadosCidade = useSelector(selectCidade);
  const dadosLogin = useSelector(selectLogin);

  const [servico, setServico] = useState();

  const dispatch = useDispatch();
  const history = useHistory();

  const { id } = useParams();

  window.onload = () => {
    dispatch(resetarModais());
  };

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  const limpaLoginAnonimo = (data) => {
    if (data && data.data && data.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  const checaCidadeAtiva = (idCidade) => {
    if (idCidade) {
      fetchVerificarStatusCidade(idCidade).then((response) => {
        if (response === 'N') {
          dispatch(desfazerConexao());
          dispatch(desfazerCidade());
          dispatch(desfazerSecretaria());
          limpaLoginAnonimo(dadosLogin);
          history.push('/');
        }
      });
    } else {
      history.push('/');
    }
  };

  useEffect(() => {
    if (getTotem() === 'true') {
      // setTimeout(() => {
      //   document.querySelector('body').click();
      //   document.querySelector('body').focus();
      //   document.querySelector('body').click();
      // }, 2000);

      history.push('/totem');
    }

    if (cookieId) {
      const escolherCidadeCookie = async (Id, Campo) => {
        setCidade({ Id, Campo });
        dispatch(definirCidade({
          idCidade: Id,
          nomeCidade: Campo,
        }));
        await fetchLimparCookie();
        await dispatch(fetchConfiguracoesCidade());
      };

      dispatch(desfazerConexao());
      fetchNomeCidade(cookieId).then((nomeCidade) => escolherCidadeCookie(cookieId, nomeCidade));
    }

    if (dadosCidade && dadosCidade.configuracoes && !dadosCidade.configuracoes.CartaDeServicos) {
      history.push('/');
    }

    fetchServico(parseFloat(id)).then((response) => { setServico(response); });

    if (getTotem() !== 'true') checaCidadeAtiva(dadosCidade && dadosCidade.data && dadosCidade.data.idCidade);
  }, []);

  if (!servico) {
    return (
      <Carregar />
    );
  }

  return (
    <AppFragment
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          dispatch(resetarModais());
        }
      }}
      tabIndex="0"
    >
      {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
      {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
      {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
      <AppHeader />
      <AppBody totem={getTotem() === 'true'} desfoque={dadosModal.desfoque} className="controle-fundo">
        <Container totem={getTotem() === 'true'}>
          <Titulo totem={getTotem() === 'true'}>Carta de Serviços</Titulo>

          <h2 style={{ fontSize: '1.4em', textAlign: 'center' }}>{servico.Servico}</h2>

          {servico && servico.Message && servico.Message === 'Nenhum registro foi encontrado.' && (
            <Botao
              style={{ marginBottom: 30 }}
              link
              label="Voltar"
              onClick={() => history.push('/cartadeservicos')}
            />
          )}

          <Interno>
            {servico && servico.Message && servico.Message === 'Nenhum registro foi encontrado.' ? (
              <p>Nenhum registro foi encontrado.</p>
            ) : (
              <CardCartaServicos
                Aplicativo={servico.Aplicativo}
                Aplicativo2={servico.Aplicativo2}
                Bairro={servico.Bairro}
                Bairro2={servico.Bairro2}
                CEP={servico.CEP}
                CEP2={servico.CEP2}
                DataHoraUltimaAtualizacao={servico.DataHoraUltimaAtualizacao}
                Descricao={servico.Descricao}
                Documento={servico.Documento}
                Email={servico.Email}
                Email2={servico.Email2}
                Endereco={servico.Endereco}
                Endereco2={servico.Endereco2}
                HorarioFuncionamentoAte={servico.HorarioFuncionamentoAte}
                HorarioFuncionamentoAte2={servico.HorarioFuncionamentoAte2}
                HorarioFuncionamentoAte3={servico.HorarioFuncionamentoAte3}
                HorarioFuncionamentoAte4={servico.HorarioFuncionamentoAte4}
                HorarioFuncionamentoDe={servico.HorarioFuncionamentoDe}
                HorarioFuncionamentoDe2={servico.HorarioFuncionamentoDe2}
                HorarioFuncionamentoDe3={servico.HorarioFuncionamentoDe3}
                HorarioFuncionamentoDe4={servico.HorarioFuncionamentoDe4}
                LinkDecreto={servico.LinkDecreto}
                LinkLei={servico.LinkLei}
                LinkOutros={servico.LinkOutros}
                LinkPortaria={servico.LinkPortaria}
                LinkPrograma={servico.LinkPrograma}
                LinkResolucao={servico.LinkResolucao}
                LinkTaxa={servico.LinkTaxa}
                // NumeroGLPI={servico.NumeroGLPI}
                Plataforma={servico.Plataforma}
                // PossuiNumeroGLPI={servico.PossuiNumeroGLPI}
                Prazo={servico.Prazo}
                PrazoObservacao={servico.PrazoObservacao}
                PrincipaisEtapas={servico.PrincipaisEtapas}
                PublicoAlvo={servico.PublicoAlvo}
                Secretaria={servico.Secretaria}
                Servico={servico.Servico}
                Setor={servico.Setor}
                Site={servico.Site}
                Telefone01={servico.Telefone01}
                Telefone02={servico.Telefone02}
                Telefone03={servico.Telefone03}
                Telefone04={servico.Telefone04}
                Valor={servico.Valor}
              />
            )}
          </Interno>
        </Container>
      </AppBody>
    </AppFragment>
  );
};

export default IniciarCartaServicos;
